import cn from 'classnames';
import * as React from 'react';
import { useCallback } from 'react';

import styles from './styles.module.scss';

export interface AccordionProps {
  className?: string;
}

const Accordion: React.FC<AccordionProps> = ({ className, ...rest }) => {
  const handleClickCapture = useCallback((event: React.MouseEvent<HTMLDivElement>) => {
    const headerButton = (event.target as HTMLElement).closest(
      'button.erom-accordion-item-header'
    ) as HTMLButtonElement | null;
    event.stopPropagation();
    if (headerButton) {
      const parent = headerButton.closest('.erom-accordion-container') || document;
      const allHeaders = parent.querySelectorAll('button.erom-accordion-item-header');
      const allContents = parent.querySelectorAll('.erom-accordion-item-content');
      const isExpanded = headerButton.getAttribute('aria-expanded') === 'true';
      const contentId = headerButton.getAttribute('aria-controls');
      const content = contentId ? parent.querySelector(`#${contentId}`) : null;

      if (isExpanded) {
        headerButton.setAttribute('aria-expanded', 'false');
        if (content) content.setAttribute('hidden', 'true');
      } else {
        // Collapse all, then expand this one
        allHeaders.forEach(btn => btn.setAttribute('aria-expanded', 'false'));
        allContents.forEach(c => c.setAttribute('hidden', 'true'));
        headerButton.setAttribute('aria-expanded', 'true');
        if (content) content.removeAttribute('hidden');
      }
    }
  }, []);

  return <div onClickCapture={handleClickCapture} className={cn(styles.accordion, className)} {...rest} />;
};

export default Accordion;
